import React, { Fragment, useEffect, useState } from "react";
import "./OnlineFraming.css";
import Header from "../../Components/Layout/Header";
import { Box, Container, Grid, Link, Slider, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import guaranty from "../../Assets/Quality Guaranteed Icon.png";
import backBoard from "../../Assets/frames/BackingBoard.webp";
import Parse from "../../API/ParseServer";
import { useNavigate, useParams } from "react-router-dom";
import Footer from "../../Components/Layout/Footer";
import flip from "../../Assets/flip.png";
import backTray from "../../Assets/frames/tray-back.jpg";
import trayGuide from "../../Assets/frames/tray.jpg";
import trayDark from "../../Assets/frames/tray-dark.jpg";
import { useCart } from "../../Context/CartContext";
interface StyledTabsProps {
  children?: React.ReactNode;
  value: number;
  onChange: (event: React.SyntheticEvent, newValue: number) => void;
}
interface frame {
  name: string;
  frameImage: string;
  isSelected: boolean;
  desription: string;
  type: string;
  summary: string;
  width: number;
  depth: number;
  icon: string;
  side: string;
  id: string;
  sort: number;
  price: number;
  style: string;
}
// const frames: frame[] = [
//   {
//     name: "Wide Panther Smooth",
//     image: widePantherSmooth,
//     isSelected: false,
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//     desription: "",
//     type: "black",
//   },
//   {
//     name: "Wide Panther Textured",
//     image: widePantherTextured,
//     isSelected: false,
//     desription: "",
//     type: "black",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Deep Panther Smooth",
//     image: deepPantherSmooth,
//     isSelected: false,
//     desription: "",
//     type: "black",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Deep Panther Textured",
//     image: deepPantherTextured,
//     isSelected: false,
//     desription: "",
//     type: "black",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Panther Smooth",
//     image: pantherSmooth,
//     isSelected: false,
//     desription: "",
//     type: "black",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Panther Textured",
//     image: pantherTextured,
//     isSelected: false,
//     desription: "",
//     type: "black",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Wide Snow Smooth",
//     image: wideSnowSmooth,
//     isSelected: false,
//     desription: "",
//     type: "white",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Wide Snow Textured",
//     image: wideSnowTextured,
//     isSelected: false,
//     desription: "",
//     type: "white",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Deep Snow Smooth",
//     image: deepSnowSmooth,
//     isSelected: false,
//     desription: "",
//     type: "white",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Deep Snow Textured",
//     image: deepSnowTextured,
//     isSelected: false,
//     desription: "",
//     type: "white",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Snow Smooth",
//     image: snowSmooth,
//     isSelected: false,
//     desription: "",
//     type: "white",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Snow Textured",
//     image: snowTextured,
//     isSelected: false,
//     desription: "",
//     type: "white",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Wide Grey Textured",
//     image: wideGreyTextured,
//     isSelected: false,
//     desription: "",
//     type: "luxury",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Grey Textured",
//     image: greyTextured,
//     isSelected: false,
//     desription: "",
//     type: "luxury",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Luxury Gold",
//     image: luxuryGold,
//     isSelected: false,
//     desription: "",
//     type: "luxury",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
//   {
//     name: "Luxury Silver",
//     image: luxurySilver,
//     isSelected: false,
//     desription: "",
//     type: "luxury",
//     summary: "Smooth Matte Finish",
//     deep: 15,
//     wide: 30,
//   },
// ];
const StyleTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{
      children: <span className="MuiTabs-indicatorSpan" />,
    }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  boxSizing: "inherit",
});

interface StyleTabProps {
  label: string;
}

const StyleTab = styled((props: StyleTabProps) => <Tab {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(17),
    // marginRight: theme.spacing(1),
    padding: "10px",
    width: "auto",
    minWidth: "1.5rem",
    minHeight: "1rem",
    color: "black",
    "&.Mui-selected": {
      color: "#863a18",
      backgroundColor: "#ececec",
      borderRadius: "5px",
    },
  }),
);
interface StyleTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function StyleTabPanel(props: StyleTabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}
function styleA11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
const TypeTabs = styled((props: StyledTabsProps) => (
  <Tabs
    {...props}
    TabIndicatorProps={{
      children: <span className="MuiTabs-indicatorSpan" />,
    }}
  />
))({
  "& .MuiTabs-indicator": {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
  },
  boxSizing: "inherit",
});

interface TypeTabProps {
  label: string;
}

const TypeTab = styled((props: TypeTabProps) => <Tab {...props} />)(
  ({ theme }) => ({
    textTransform: "none",
    fontWeight: theme.typography.fontWeightBold,
    fontSize: theme.typography.pxToRem(17),
    // marginRight: theme.spacing(1),
    padding: "10px",
    width: "auto",
    minWidth: "1.5rem",
    minHeight: "1rem",
    color: "black",
    "&.Mui-selected": {
      color: "#863a18",
      backgroundColor: "#ececec",
      borderRadius: "5px",
    },
  }),
);
interface TypeTabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
function TypeTabPanel(props: TypeTabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
    </div>
  );
}
function TypeA11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const mountBoxShadow =
  "0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)";

const MountSlider = styled(Slider)(({ theme }) => ({
  color: "#cccccc",
  height: 20,
  borderRadius: "5px",
  padding: "15px 0",
  "& .MuiSlider-thumb": {
    borderRadius: "5px",

    height: 25,
    width: 30,
    backgroundColor: "#fff",
    boxShadow: "0 0 2px 0px rgba(0, 0, 0, 0.1)",
    "&:focus, &:hover, &.Mui-active": {
      boxShadow: "0px 0px 3px 1px rgba(0, 0, 0, 0.1)",
      // Reset on touch devices, it doesn't add specificity
      "@media (hover: none)": {
        boxShadow: mountBoxShadow,
      },
    },
    "&:before": {
      boxShadow:
        "0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)",
    },
  },
  "& .MuiSlider-valueLabel": {
    fontSize: 10,
    fontWeight: "normal",
    top: -6,
    backgroundColor: "white",
    border: "1px solid gray",
    borderRadius: "5px",

    color: theme.palette.text.primary,
    "&::before": {
      display: "none",
    },
    "& *": {
      background: "transparent",
      color: theme.palette.mode === "dark" ? "#fff" : "#000",
    },
  },
  "& .MuiSlider-track": {
    border: "none",
    height: 20,
  },
  "& .MuiSlider-rail": {
    opacity: 0.5,
    boxShadow: "inset 0px 0px 4px -2px #000",
    backgroundColor: "white",
    border: "1px solid gray",
  },
}));
const marks = [
  {
    value: 0,
  },
  {
    value: 3,
  },
  {
    value: 4,
  },
  {
    value: 5,
  },
  {
    value: 6,
  },
  {
    value: 7,
  },
  {
    value: 8,
  },
  {
    value: 9,
  },
  {
    value: 10,
  },
];
function valuetext(value: number) {
  if (value === 0) return "no mount";
  else return `${value}cm mount`;
}

const OnlineFraming = () => {
  const [currentSide, setCurrentSide] = useState("front");
  function changeSide() {
    if (currentSide === "front") {
      setCurrentSide("right");
    } else {
      setCurrentSide("front");
    }
  }
  const [frameIsHovered, setFrameIsHovered] = useState(false);
  const params = useParams();
  const [typeValue, setTypeValue] = React.useState(0);
  const typeTabChangeHandler = (
    event: React.SyntheticEvent,
    newValue: number,
  ) => {
    setTypeValue(newValue);
  };
  const [styleValue, setStyleValue] = React.useState(0);

  const styleTabChangeHandler = (
    event: React.SyntheticEvent,
    newValue: number,
  ) => {
    setStyleValue(newValue);
  };
  const [mount, setMount] = useState<number>();
  const mountChangeHandler = (event: any) => {
    setMount(event.target.value * 2);
  };
  const [mountColor, setMountColor] = useState("ffffff");
  const mountColorChangeHandler = (event: any) => {
    if (event.target.id) setMountColor(event.target.id);
    else setMountColor(event.target.parentElement.id);
  };
  const [selectedFrame, setSelectedFrame] = useState<frame | undefined>();
  const [framingLoading, setFramingLoading] = useState(true);
  const [tray, setTray] = useState(0);
  const frameChangeHandler = (event: any) => {
    setSelectedFrame(
      frames.find((frame: frame) => frame.name === event.target.id),
    );
    if (
      frames.find((frame: frame) => frame.name === event.target.id)?.style ===
      "tray"
    ) {
      setTray(1);
      setMount(0);
    } else setTray(0);

    setFramingLoading(true);
    setTimeout(() => {
      setFramingLoading(false);
    }, 5000);
  };
  const [selectedGlass, setSelectedGlass] = useState("Art Acrylic 2mm");
  const glassChangeHandler = (event: any) => {
    setSelectedGlass(event.target.id);
  };
  const [criteria, setCriteria] = useState("wl");
  const [userArtwork, setUserArtwork] = useState<any>();
  const [artwork, setArtwork] = useState<any>();
  const [artworkPrice, setArtworkPrice] = useState(0);
  const [pictureUrl, setPictureUrl] = useState("");
  const [error, setError] = useState("");
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [cm, setCm] = useState(10);
  const [title, setTitle] = useState("");
  const [fetchLoading, setFetchLoading] = useState(false);
  const [uploadLoading, setUploadLoading] = useState(false);
  // const artworkId = localStorage.getItem("uploadImageId");
  const [frames, setFrames] = useState<frame[]>([]);
  const [pricing, setPricing] = useState<any>();
  useEffect(() => {
    const fetchFrames = async () => {
      const query = new Parse.Query("Frame");
      query.ascending("sort");
      try {
        const results = await query.find();
        results.forEach((result: any) => {
          setFrames((current) => {
            if (!current.find((cur: any) => cur.name === result.get("name"))) {
              return [
                ...current,
                {
                  name: result.get("name"),
                  icon: result.get("icon").url(),
                  frameImage: result.get("frameImage").url(),
                  isSelected: false,
                  desription: result.get("description"),
                  type: result.get("type"),
                  summary: result.get("summary"),
                  width: result.get("width"),
                  depth: result.get("depth"),
                  side: result.get("sideImage").url(),
                  id: result.id,
                  sort: result.get("sort"),
                  price: result.get("price"),
                  style: result.get("style"),
                },
              ];
            } else return [...current];
          });
        });
        // if (!selectedFrame)
        //   setSelectedFrame({
        //     name: results[0].get("name"),
        //     icon: results[0].get("icon").url(),
        //     frameImage: results[0].get("frameImage").url(),
        //     isSelected: false,
        //     desription: results[0].get("description"),
        //     type: results[0].get("type"),
        //     summary: results[0].get("summary"),
        //     width: results[0].get("width"),
        //     depth: results[0].get("depth"),
        //     side: results[0].get("sideImage").url(),
        //     id: results[0].id,
        //   });
        if (!mount) setMount(0);
        // setFrames(results);

        // console.log(results[0].get("images").id);
      } catch (err: any) {
        setError(err.message);
      } finally {
        // setLoading(false);
      }
    };

    fetchFrames();

    const fetchUserArtworkById = async (artworkId: string) => {
      setError("");
      setFetchLoading(true);
      const query = new Parse.Query("UserArtwork");
      try {
        const artwork = await query.get(artworkId);
        console.log(artwork.get("resizedImage").url());
        setUserArtwork(artwork);
        setPictureUrl(artwork.get("resizedImage").url());
        setTitle(artwork.get("title"));
        setFetchLoading(false);
      } catch (error) {
        setFetchLoading(false);

        console.error("Error fetching artwork:", error);
        setError("Error fetching artwork please try again");
      } finally {
      }
    };

    const fetchArtworkById = async (artworkId: string) => {
      setError("");
      setFetchLoading(true);
      const query = new Parse.Query("Artwork");
      query.equalTo("objectId", artworkId);
      try {
        const results = await query.find();
        if (results.length > 0) {
          console.log(results[0].get("framingImage").url());
          setArtwork(results[0]);
          setArtworkPrice(results[0].get("price"));
          setPictureUrl(results[0].get("framingImage").url());
          setTitle(results[0].get("title"));
          setFetchLoading(false);
        }
      } catch (error) {
        setFetchLoading(false);

        console.error("Error fetching artwork:", error);
        setError("Error fetching artwork please try again");
      } finally {
      }
    };
    const fetchDefault = async () => {
      setPictureUrl(backBoard);
    };
    if (
      localStorage.getItem("inputWidth") &&
      localStorage.getItem("inputHeight")
    ) {
      setWidth(Number(localStorage.getItem("inputWidth")));
      setHeight(Number(localStorage.getItem("inputHeight")));
    } else {
      setWidth(20);
      setHeight(20);
    }
    if (localStorage.getItem("framingMode") === "artwork")
      fetchArtworkById(String(localStorage.getItem("artworkId")));
    else if (localStorage.getItem("framingMode") === "user")
      fetchUserArtworkById(String(localStorage.getItem("uploadImageId")));
    else fetchDefault();
    const fetchPricing = async () => {
      const pricingQuery = new Parse.Query("Pricing");
      try {
        const results = await pricingQuery.find();
        setPricing(results[0]);
        console.log(results[0]);
      } catch (err: any) {
        setError(err.message);
      } finally {
        // setLoading(false);
      }
    };
    fetchPricing();
  }, [
    localStorage.getItem("uploadImageId"),
    localStorage.getItem("artworkTitle"),
  ]);
  const { setTotalQuantity } = useCart();
  useEffect(() => {
    const fetchItem = async () => {
      if (params.mode === "edit" && localStorage.getItem("editItemId")) {
        // setLoading(true);
        const user = Parse.User.current();
        if (user || localStorage.getItem("guestId")) {
          try {
            const basket = await Parse.Cloud.run("getBasket", {
              user: user ? user.id : localStorage.getItem("guestId"),
            });

            const item = basket
              .get("items")
              .find(
                (item: any) =>
                  item.itemId === localStorage.getItem("editItemId"),
              );
            if (item) {
              setSelectedGlass(item.specifications.glass);
              setSelectedFrame(
                frames.find(
                  (frame: frame) => frame.name === item.frame.get("name"),
                ),
              );
              if (
                frames.find(
                  (frame: frame) => frame.name === item.frame.get("name"),
                )?.style === "tray"
              ) {
                setStyleValue(1);
                setTray(1);
              }
              if (item.specifications.mountboard.color) {
                // setFramingLoading(true);
                // setTimeout(() => {
                //   setFramingLoading(false);
                // }, 5000);
                setMountColor(item.specifications.mountboard.color);
                setMount(item.specifications.mountboard.size * 2);
                console.log(item.specifications.mountboard.size);
              } else setMount(0);
            }
            let totalQuantity = 0;
            basket.get("items").forEach((item: any) => {
              totalQuantity += item.quantity;
            });
            setTotalQuantity(totalQuantity);
            localStorage.setItem("totalQuantity", String(totalQuantity));
          } catch (error) {
            console.error("Error fetching basket:", error);
          } finally {
            // setLoading(false);
          }
        }
      } else {
        setSelectedFrame(frames[0]);
        setFramingLoading(true);
        setTimeout(() => {
          setFramingLoading(false);
        }, 5000);
      }
    };
    fetchItem();
  }, [frames]);
  useEffect(() => {
    if (selectedFrame)
      if (Math.max(width, height) > 7) {
        if (window.screen.width < 900) {
          if (height / width > 3) {
            setCm(600 / (height + selectedFrame.width / 5 + (mount || 0)));
          } else {
            setCm(
              (window.screen.width * 0.8) /
                (width + selectedFrame.width / 5 + (mount || 0)),
            );
          }
        } else if (width < height) {
          setCm(
            Math.min(window.screen.width * 0.45, 570) /
              (height + selectedFrame.width / 5 + (mount || 0)),
          );
        } else {
          setCm(
            Math.min(window.screen.width * 0.45, 570) /
              (width + selectedFrame.width / 5 + (mount || 0)),
          );
        }
      } else {
        setCm(32 - (mount || 0) - (2 * selectedFrame.width) / 10);
      }
  }, [frames, mount, selectedFrame, width, height]);
  const navigate = useNavigate();
  const uid = function () {
    return (
      Date.now().toString(36) +
      Math.floor(
        Math.pow(10, 12) + Math.random() * 9 * Math.pow(10, 12),
      ).toString(36)
    );
  };
  const guestId = localStorage.getItem("guestId")
    ? localStorage.getItem("guestId")
    : uid();
  const addCartHandler = async () => {
    const user = Parse.User.current();
    if (localStorage.getItem("framingMode") === "artwork") {
      if (user)
        await Parse.Cloud.run("addToBasket", {
          user: user.id,
          artworkId: artwork.id,
          quantity: 1,
          frameId: selectedFrame?.id,
          specifications: {
            glass: selectedGlass,
            mountboard: !mount ? {} : { color: mountColor, size: mount / 2 },
            width: localStorage.getItem("inputWidth"),
            height: localStorage.getItem("inputHeight"),
          },
          type: "ArtworkFrame",
          itemId: localStorage.getItem("editItemId")
            ? localStorage.getItem("editItemId")
            : "",
        });
      else {
        await Parse.Cloud.run("addToBasket", {
          user: guestId,
          artworkId: artwork.id,
          quantity: 1,
          frameId: selectedFrame?.id,
          specifications: {
            glass: selectedGlass,
            mountboard: !mount ? {} : { color: mountColor, size: mount / 2 },
            width: localStorage.getItem("inputWidth"),
            height: localStorage.getItem("inputHeight"),
          },
          type: "ArtworkFrame",
          itemId: localStorage.getItem("editItemId")
            ? localStorage.getItem("editItemId")
            : "",
        });
        if (guestId) localStorage.setItem("guestId", guestId);
      }
    } else if (localStorage.getItem("framingMode") === "user") {
      if (user)
        await Parse.Cloud.run("addToBasket", {
          user: user.id,
          artworkId: userArtwork.id,
          quantity: 1,
          frameId: selectedFrame?.id,
          specifications: {
            paper: localStorage.getItem("selectedPaper"),
            width: localStorage.getItem("inputWidth"),
            height: localStorage.getItem("inputHeight"),
            glass: selectedGlass,
            mountboard: !mount ? {} : { color: mountColor, size: mount / 2 },
          },
          type: "UserArtworkFrame",
          itemId: localStorage.getItem("editItemId")
            ? localStorage.getItem("editItemId")
            : "",
        });
      else {
        await Parse.Cloud.run("addToBasket", {
          user: guestId,
          artworkId: userArtwork.id,
          quantity: 1,
          frameId: selectedFrame?.id,
          specifications: {
            paper: localStorage.getItem("selectedPaper"),
            width: localStorage.getItem("inputWidth"),
            height: localStorage.getItem("inputHeight"),
            glass: selectedGlass,
            mountboard: !mount ? {} : { color: mountColor, size: mount / 2 },
          },
          type: "UserArtworkFrame",
          itemId: localStorage.getItem("editItemId")
            ? localStorage.getItem("editItemId")
            : "",
        });
        if (guestId) localStorage.setItem("guestId", guestId);
      }
    } else {
      if (user)
        await Parse.Cloud.run("addToBasket", {
          user: user.id,
          artworkId: "",
          quantity: 1,
          frameId: selectedFrame?.id,
          specifications: {
            width: localStorage.getItem("inputWidth"),
            height: localStorage.getItem("inputHeight"),
            glass: selectedGlass,
            mountboard: !mount ? {} : { color: mountColor, size: mount / 2 },
          },
          type: "Frame",
          itemId: localStorage.getItem("editItemId")
            ? localStorage.getItem("editItemId")
            : "",
        });
      else {
        await Parse.Cloud.run("addToBasket", {
          user: guestId,
          artworkId: "",
          quantity: 1,
          frameId: selectedFrame?.id,
          specifications: {
            width: localStorage.getItem("inputWidth"),
            height: localStorage.getItem("inputHeight"),
            glass: selectedGlass,
            mountboard: !mount ? {} : { color: mountColor, size: mount / 2 },
          },
          type: "Frame",
          itemId: localStorage.getItem("editItemId")
            ? localStorage.getItem("editItemId")
            : "",
        });
        if (guestId) localStorage.setItem("guestId", guestId);
      }
    }
    localStorage.removeItem("framingMode");
    localStorage.removeItem("selectedPaper");

    localStorage.removeItem("inputHeight");
    localStorage.removeItem("inputWidth");
    localStorage.removeItem("uploadImageId");
    localStorage.removeItem("artworkTitle");
    localStorage.removeItem("editItemId");

    navigate("/cart");
  };

  return (
    <React.Fragment>
      <Grid container sx={{ mt: 3, mb: 20 }}>
        <Grid
          item
          xs={12}
          md={6.5}
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            // justifyContent: "center",
            alignItems: "center",
            pt: 15,
            position: "relative",
            // backgroundColor: "#f8f8f8",
            height: `${
              (height +
                (mount || 0) +
                (selectedFrame ? selectedFrame.width : 5) / 5) *
                cm +
              300
            }px`,
            // pt: 8,
          }}
        >
          {/* {framingLoading && (
            <Box
              sx={{
                position: "absolute",
                zIndex: 1000,
                width: "100%",
                height: "100%",
                top: 0,
                left: 0,
                display: "flex",
                justifyContent: "center",

                // alignItems: "center",
                pt: 30,
                backgroundColor: "white",
              }}
            >
              <span className="loader"></span>
            </Box>
          )} */}
          {selectedFrame && mount?.toString().length && (
            <Box
              className="scene"
              sx={{
                width: `${(width + mount + tray * 2 + selectedFrame.width / 5) * cm}px`,
                height: `${(height + mount + tray * 2 + selectedFrame.width / 5) * cm}px`,
                perspective: `${
                  (width + mount + tray * 2 + selectedFrame.width / 5) * cm +
                  (height + mount + tray * 2 + selectedFrame.width / 5) * cm
                }px`,
                mt: { xs: 8, md: 0 },
              }}
              onMouseEnter={() => setFrameIsHovered(true)}
              onMouseLeave={() => setFrameIsHovered(false)}
            >
              <Box
                className={"cube"}
                id="cube"
                sx={{
                  transform: `${
                    !frameIsHovered ? "rotateY(0deg)" : "rotateY(-45deg)"
                  }`,
                  height: `${
                    (height + mount + tray * 2 + selectedFrame.width / 5) * cm
                  }px`,
                }}
              >
                <Box
                  className={`cube__face`}
                  sx={{
                    borderImageSlice: "200",
                    background: "transparent",
                    boxShadow: "rgba(0, 0, 0, 0.7) 0px 2px 5px inset",
                    transform: `rotateY(0deg) translateZ(${
                      (selectedFrame.depth / 20) * cm
                    }px)`,
                    transition: "all 800ms",
                    borderStyle: "solid",
                    borderImageSource: `url(${selectedFrame.frameImage})`,
                    borderImageWidth: `${(selectedFrame.width / 10) * cm + 1}px`,
                    borderImageRepeat: "stretch",
                    zIndex: "10",
                    width: `${
                      (width + mount + tray * 2 + selectedFrame.width / 5) * cm
                    }px`,
                    height: `${
                      (height + mount + tray * 2 + selectedFrame.width / 5) * cm
                    }px`,
                  }}
                ></Box>
                <Box
                  sx={{
                    transform: `rotateY(0deg) translateZ(${
                      (selectedFrame.depth / 20) * cm - 8
                    }px)`,
                    width: `${(width + mount) * cm}px`,
                    height: `${(height + mount) * cm}px`,
                    border: `${(mount / 2) * cm}px solid #${mountColor}`,
                    transition: "all 800ms",
                    position: "absolute",
                    zIndex: "10",
                    left: `${(selectedFrame.width / 10) * cm}px`,
                    top: `${(selectedFrame.width / 10) * cm}px`,
                  }}
                ></Box>
                <Box
                  sx={{
                    transform: `rotateY(0deg) translateZ(${
                      (selectedFrame.depth / 20) * cm - 5
                    }px)`,
                    width: `${width * cm}px`,
                    height: `${height * cm}px`,
                    transition: "all 800ms",
                    background: `url(${tray ? backTray : pictureUrl}) no-repeat center`,
                    backgroundSize: "100% 100%",
                    position: "absolute",
                    zIndex: "50",
                    objectFit: "fill",
                    left: `${(mount / 2 + selectedFrame.width / 10 + tray) * cm}px`,
                    top: `${(mount / 2 + selectedFrame.width / 10 + tray) * cm}px`,
                  }}
                ></Box>
                <Box
                  //back
                  className={`cube__face`}
                  sx={{
                    transform: `rotateY(180deg) translateZ(${
                      (selectedFrame.depth / 20) * cm
                    }px)`,
                    transition: "all 800ms",
                    width: `${
                      (width + mount + tray * 2 + selectedFrame.width / 5) * cm
                    }px`,
                    height: `${
                      (height + mount + tray * 2 + selectedFrame.width / 5) * cm
                    }px`,
                    background: `url(${tray && selectedFrame.side})`,
                    // backgroundColor: "#c7c7c7",
                  }}
                ></Box>
                <Box
                  //back
                  className={`cube__face`}
                  sx={{
                    transform: `rotateY(180deg) translateZ(${
                      (selectedFrame.depth / 20) * cm
                    }px)`,
                    transition: "all 800ms",
                    width: `${
                      (width + mount + tray * 2 + selectedFrame.width / 5) * cm
                    }px`,
                    height: `${
                      (height + mount + tray * 2 + selectedFrame.width / 5) * cm
                    }px`,
                    // background: `url(${tray && selectedFrame.side})`,
                    backgroundColor: "black",
                    opacity: "15%",
                  }}
                ></Box>
                <Box
                  //right
                  className={`cube__face`}
                  sx={{
                    background: ` url(${selectedFrame.side}) round`,
                    transform: `rotateY(90deg) translateZ(${
                      (width +
                        selectedFrame.width / 5 +
                        mount +
                        tray * 2 -
                        selectedFrame.depth / 20) *
                      cm
                    }px)`,
                    transition: "all 800ms",
                    width: `${(selectedFrame.depth / 10) * cm}px`,
                    height: `${
                      (height + mount + tray * 2 + selectedFrame.width / 5) * cm
                    }px`,
                  }}
                ></Box>
                <Box
                  //innerright
                  className={`cube__face`}
                  sx={{
                    background: ` url(${selectedFrame.side}) round`,
                    transform: `rotateY(90deg) translateZ(${
                      (width +
                        selectedFrame.width / 10 +
                        mount +
                        tray * 2 -
                        selectedFrame.depth / 20) *
                      cm
                    }px)`,
                    transition: "all 800ms",
                    width: `${(selectedFrame.depth / 10) * cm}px`,
                    height: `${(height + mount + tray * 2) * cm}px`,
                    top: `${(selectedFrame.width / 10) * cm}px`,
                  }}
                ></Box>
                <Box
                  //innertrayright
                  className={`cube__face`}
                  sx={{
                    // background: ` url(${tray ? trayDark : pictureUrl}) round`,
                    backgroundColor: "#e0e0e0",
                    transform: `rotateY(90deg) translateZ(${
                      (width + selectedFrame.width / 20) * cm - 0.5
                    }px)`,
                    transition: "all 800ms",
                    width: `${(selectedFrame.depth / 10) * cm - 1}px`,
                    height: `${height * cm - 2}px`,
                    top: `${(selectedFrame.width / 10 + tray) * cm}px`,
                    opacity: `${tray ? "100%" : "0"}`,
                  }}
                ></Box>
                {mount > 0 && (
                  <Box
                    //mountright
                    className={`cube__face`}
                    sx={{
                      backgroundColor: `#${mountColor} `,
                      transform: `rotateY(90deg) translateZ(${
                        (width +
                          selectedFrame.width / 10 +
                          mount / 2 -
                          selectedFrame.depth / 20) *
                        cm
                      }px)`,
                      transition: "all 800ms",
                      width: `${(selectedFrame.depth / 10) * cm}px`,
                      height: `${height * cm}px`,
                      top: `${(selectedFrame.width / 10 + mount / 2) * cm}px`,
                    }}
                  ></Box>
                )}
                <Box
                  //left
                  className={`cube__face`}
                  sx={{
                    background: ` url(${selectedFrame.side}) round`,
                    transform: `rotateY(-90deg) translateZ(${
                      (selectedFrame.depth / 20) * cm
                    }px)`,
                    transition: "all 800ms",
                    width: `${(selectedFrame.depth / 10) * cm}px`,
                    height: `${
                      (height + mount + tray * 2 + selectedFrame.width / 5) * cm
                    }px`,
                  }}
                ></Box>
                <Box
                  //innerleft
                  className={`cube__face`}
                  sx={{
                    background: ` url(${selectedFrame.side}) round`,
                    transform: `rotateY(-90deg) translateZ(${
                      (selectedFrame.depth / 20 - selectedFrame.width / 10) * cm
                    }px)`,
                    transition: "all 800ms",
                    width: `${(selectedFrame.depth / 10) * cm}px`,
                    height: `${(height + mount + tray * 2) * cm}px`,
                    top: `${(selectedFrame.width / 10) * cm}px`,
                  }}
                ></Box>
                {mount > 0 && (
                  <Box
                    //mountleft
                    className={`cube__face`}
                    sx={{
                      backgroundColor: "white",
                      transform: `rotateY(-90deg) translateZ(${
                        (selectedFrame.depth / 20 -
                          selectedFrame.width / 10 -
                          mount / 2) *
                        cm
                      }px)`,
                      transition: "all 800ms",
                      width: `${(selectedFrame.depth / 10) * cm}px`,
                      height: `${height * cm}px`,
                      top: `${(selectedFrame.width / 10 + mount / 2) * cm}px`,
                    }}
                  ></Box>
                )}
                <Box
                  //top
                  className={`cube__face`}
                  sx={{
                    background: ` url(${selectedFrame.side}) round`,
                    transform: `rotateX(90deg) translateZ(${
                      (selectedFrame.depth / 20) * cm
                    }px)`,
                    transition: "all 800ms",
                    height: `${(selectedFrame.depth / 10) * cm}px`,
                    width: `${
                      (width + mount + tray * 2 + selectedFrame.width / 5) * cm
                    }px`,
                  }}
                ></Box>
                <Box
                  //innertop
                  className={`cube__face`}
                  sx={{
                    background: ` url(${selectedFrame.side}) round`,
                    transform: `rotateX(90deg) translateZ(${
                      (selectedFrame.depth / 20 - selectedFrame.width / 10) * cm
                    }px)`,
                    transition: "all 800ms",
                    height: `${(selectedFrame.depth / 10) * cm}px`,
                    width: `${(width + mount + tray * 2) * cm}px`,
                    left: `${(selectedFrame.width / 10) * cm}px`,
                  }}
                ></Box>

                {mount > 0 && (
                  <Box
                    //mounttop
                    className={`cube__face`}
                    sx={{
                      backgroundColor: `#${mountColor}`,
                      transform: `rotateX(90deg) translateZ(${
                        (selectedFrame.depth / 20 -
                          selectedFrame.width / 10 -
                          mount / 2) *
                        cm
                      }px)`,
                      transition: "all 800ms",
                      height: `${(selectedFrame.depth / 10) * cm}px`,
                      width: `${width * cm}px`,
                      left: `${(selectedFrame.width / 10 + mount / 2) * cm}px`,
                    }}
                  ></Box>
                )}
                <Box
                  //bottom
                  className={`cube__face`}
                  sx={{
                    background: ` url(${selectedFrame.side}) round`,
                    transform: `rotateX(-90deg) translateZ(${
                      (height +
                        selectedFrame.width / 5 +
                        mount +
                        tray * 2 -
                        selectedFrame.depth / 20) *
                      cm
                    }px)`,
                    transition: "all 800ms",
                    height: `${(selectedFrame.depth / 10) * cm}px`,
                    width: `${
                      (width + mount + tray * 2 + selectedFrame.width / 5) * cm
                    }px`,
                  }}
                ></Box>
                <Box
                  //inner bottom
                  className={`cube__face`}
                  sx={{
                    background: ` url(${selectedFrame.side}) round`,
                    transform: `rotateX(-90deg) translateZ(${
                      (height +
                        selectedFrame.width / 10 +
                        mount +
                        tray * 2 -
                        selectedFrame.depth / 20) *
                      cm
                    }px)`,
                    transition: "all 800ms",
                    height: `${(selectedFrame.depth / 10) * cm}px`,
                    width: `${(width + mount + tray * 2) * cm}px`,
                    left: `${(selectedFrame.width / 10) * cm}px`,
                  }}
                ></Box>
                {mount > 0 && (
                  <Box
                    //mount bottom
                    className={`cube__face`}
                    sx={{
                      backgroundColor: `#${mountColor}`,
                      transform: `rotateX(-90deg) translateZ(${
                        (height +
                          selectedFrame.width / 10 +
                          mount / 2 -
                          selectedFrame.depth / 20) *
                        cm
                      }px)`,
                      transition: "all 800ms",
                      height: `${(selectedFrame.depth / 10) * cm}px`,
                      width: `${width * cm}px`,
                      left: `${(selectedFrame.width / 10 + mount / 2) * cm}px`,
                    }}
                  ></Box>
                )}
              </Box>
            </Box>
          )}{" "}
          {
            // <button onClick={changeSide} className={"side-button"}>
            //   <img alt="flip" src={flip} style={{ width: "100%" }} />
            // </button>
          }
        </Grid>

        <Grid
          item
          xs={12}
          md={5.5}
          sx={{ pr: { md: 20, xs: 3 }, pl: { md: 6, xs: 3 } }}
        >
          <Typography variant="h5" component="h2" sx={{ mb: 2 }}>
            {selectedFrame?.name && selectedFrame.name}
          </Typography>
          <Typography sx={{ color: "#949494" }}>
            {selectedFrame && selectedFrame.summary} |{" "}
            {selectedFrame && selectedFrame.width} mm wide and{" "}
            {selectedFrame && selectedFrame.depth} mm deep
            <br />
            <br />
            {selectedFrame && selectedFrame.desription}
          </Typography>
          <br />
          {localStorage.getItem("framingMode") === "frame" ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <StyleTabs
                value={styleValue}
                onChange={styleTabChangeHandler}
                aria-label="style tabs example"
              >
                <StyleTab label="Classic" {...styleA11yProps(0)} />
                <StyleTab label="Tray/Floater" {...styleA11yProps(1)} />
              </StyleTabs>
              <TypeTabs
                value={typeValue}
                onChange={typeTabChangeHandler}
                aria-label="type tabs example"
              >
                {frames.filter((frame) => {
                  if (styleValue === 0) return frame.style === "classic";
                  else return frame.style === "tray";
                }).length > 0 && <TypeTab label="All" {...TypeA11yProps(0)} />}
                {frames
                  .filter((frame) => {
                    if (styleValue === 0) return frame.style === "classic";
                    else return frame.style === "tray";
                  })
                  .filter((frame: frame) => frame.type === "white").length >
                  0 && <TypeTab label="White" {...TypeA11yProps(1)} />}
                {frames
                  .filter((frame) => {
                    if (styleValue === 0) return frame.style === "classic";
                    else return frame.style === "tray";
                  })
                  .filter((frame: frame) => frame.type === "black").length >
                  0 && <TypeTab label="Black" {...TypeA11yProps(2)} />}
                {frames
                  .filter((frame) => {
                    if (styleValue === 0) return frame.style === "classic";
                    else return frame.style === "tray";
                  })
                  .filter((frame: frame) => frame.type === "luxury").length >
                  0 && <TypeTab label="Luxury" {...TypeA11yProps(3)} />}
              </TypeTabs>
            </Box>
          ) : (
            <Typography
              variant="subtitle1"
              sx={{ fontWeight: "bolder", display: "inline" }}
            >
              FRAME
            </Typography>
          )}
          <TypeTabPanel value={typeValue} index={0}>
            <Grid container sx={{ display: "flex", flexWrap: "wrap" }}>
              {frames &&
                frames
                  .filter((frame) => {
                    if (styleValue === 0) return frame.style === "classic";
                    else return frame.style === "tray";
                  })
                  .map((frame: frame) => {
                    return (
                      <Grid
                        item
                        sm={12 / 8}
                        xs={12 / 5}
                        sx={{ position: "relative" }}
                      >
                        <img
                          src={frame.icon}
                          alt={frame.name}
                          className="frames"
                          onClick={frameChangeHandler}
                          id={frame.name}
                        />
                        {selectedFrame && selectedFrame.name === frame.name && (
                          <CheckCircleOutlineIcon
                            sx={{
                              position: "absolute",
                              right: "2px",
                              top: "2px",
                              color: "#863a18",
                              backgroundColor: "white",
                              borderRadius: "100%",
                            }}
                          />
                        )}
                      </Grid>
                    );
                  })}
            </Grid>
          </TypeTabPanel>
          <TypeTabPanel value={typeValue} index={1}>
            <Grid container sx={{ display: "flex", flexWrap: "wrap" }}>
              {frames &&
                frames
                  .filter((frame) => {
                    if (styleValue === 0) return frame.style === "classic";
                    else return frame.style === "tray";
                  })
                  .filter((frame: frame) => frame.type === "white")
                  .map((frame: frame) => {
                    return (
                      <Grid
                        item
                        sm={12 / 8}
                        xs={12 / 5}
                        sx={{ position: "relative" }}
                      >
                        <img
                          src={frame.icon}
                          alt={frame.name}
                          className="frames"
                          onClick={frameChangeHandler}
                          id={frame.name}
                        />
                        {selectedFrame && selectedFrame.name === frame.name && (
                          <CheckCircleOutlineIcon
                            sx={{
                              position: "absolute",
                              right: "2px",
                              top: "2px",
                              color: "#863a18",
                              backgroundColor: "white",
                              borderRadius: "100%",
                            }}
                          />
                        )}
                      </Grid>
                    );
                  })}
            </Grid>
          </TypeTabPanel>
          <TypeTabPanel value={typeValue} index={2}>
            <Grid container sx={{ display: "flex", flexWrap: "wrap" }}>
              {frames &&
                frames
                  .filter((frame) => {
                    if (styleValue === 0) return frame.style === "classic";
                    else return frame.style === "tray";
                  })
                  .filter((frame: frame) => frame.type === "black")
                  .map((frame: frame) => {
                    return (
                      <Grid
                        item
                        sm={12 / 8}
                        xs={12 / 5}
                        sx={{ position: "relative" }}
                      >
                        <img
                          src={frame.icon}
                          alt={frame.name}
                          className="frames"
                          onClick={frameChangeHandler}
                          id={frame.name}
                        />
                        {selectedFrame && selectedFrame.name === frame.name && (
                          <CheckCircleOutlineIcon
                            sx={{
                              position: "absolute",
                              right: "2px",
                              top: "2px",
                              color: "#863a18",
                              backgroundColor: "white",
                              borderRadius: "100%",
                            }}
                          />
                        )}
                      </Grid>
                    );
                  })}
            </Grid>{" "}
          </TypeTabPanel>
          <TypeTabPanel value={typeValue} index={3}>
            <Grid container sx={{ display: "flex", flexWrap: "wrap" }}>
              {frames &&
                frames
                  .filter((frame) => {
                    if (styleValue === 0) return frame.style === "classic";
                    else return frame.style === "tray";
                  })
                  .filter((frame: frame) => frame.type === "luxury")
                  .map((frame: frame) => {
                    return (
                      <Grid
                        item
                        sm={12 / 8}
                        xs={12 / 5}
                        sx={{ position: "relative" }}
                      >
                        <img
                          src={frame.icon}
                          alt={frame.name}
                          className="frames"
                          onClick={frameChangeHandler}
                          id={frame.name}
                        />
                        {selectedFrame && selectedFrame.name === frame.name && (
                          <CheckCircleOutlineIcon
                            sx={{
                              position: "absolute",
                              right: "2px",
                              top: "2px",
                              color: "#863a18",
                              backgroundColor: "white",
                              borderRadius: "100%",
                            }}
                          />
                        )}
                      </Grid>
                    );
                  })}
            </Grid>
          </TypeTabPanel>
          <br />
          {styleValue === 0 ? (
            <Box sx={{ my: 2 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bolder", display: "inline" }}
              >
                MOUNTBOARD
              </Typography>
              <Box
                sx={{
                  width: "100%",
                  marginTop: "1rem",
                  marginLeft: ".5rem",
                  display: "flex",
                  justifyContent: "space-between",
                  // alignItems: "end",
                  flexDirection: { xs: "column", md: "row" },
                  position: "relative",
                  px: { xs: 5, md: 0 },
                }}
              >
                {mount?.toString.length && (
                  <MountSlider
                    aria-label="mount slider"
                    defaultValue={mount / 2}
                    value={mount / 2}
                    valueLabelDisplay="on"
                    marks={marks}
                    step={null}
                    max={10}
                    valueLabelFormat={valuetext}
                    onChange={mountChangeHandler}
                    sx={{ width: "100%", maxWidth: { md: "20rem" }, mt: 1 }}
                  />
                )}

                {mount !== 0 && (
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      marginTop: { md: -2.5 },
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        fontWeight: "bolder",
                        display: "inline",
                        // position: "absolute",
                      }}
                    >
                      Mount color
                    </Typography>
                    <Box sx={{ display: "flex", gap: ".5rem" }}>
                      <div
                        className="mount-color"
                        style={{ backgroundColor: "#ffffff" }}
                        onClick={mountColorChangeHandler}
                        id="ffffff"
                      >
                        <CheckCircleOutlineIcon
                          sx={{
                            position: "absolute",
                            right: "-12px",
                            top: "-12px",
                            color: "#863a18",
                            backgroundColor: "white",
                            borderRadius: "100%",
                            opacity: `${mountColor === "ffffff" ? "1" : "0"}`,
                            transition: "all 200ms",
                          }}
                          id="ffffff"
                        />
                      </div>

                      <div
                        className="mount-color"
                        style={{ backgroundColor: "#fffbec" }}
                        onClick={mountColorChangeHandler}
                        id="fffbec"
                      >
                        <CheckCircleOutlineIcon
                          sx={{
                            position: "absolute",
                            right: "-12px",
                            top: "-12px",
                            color: "#863a18",
                            backgroundColor: "white",
                            borderRadius: "100%",
                            opacity: `${mountColor === "fffbec" ? "1" : "0"}`,
                            transition: "all 200ms",
                          }}
                          id="fffbec"
                        />
                      </div>
                      <div
                        className="mount-color"
                        style={{ backgroundColor: "#212121" }}
                        onClick={mountColorChangeHandler}
                        id="212121"
                      >
                        <CheckCircleOutlineIcon
                          sx={{
                            position: "absolute",
                            right: "-12px",
                            top: "-12px",
                            color: "#863a18",
                            backgroundColor: "white",
                            borderRadius: "100%",
                            opacity: `${mountColor === "212121" ? "1" : "0"}`,
                            transition: "all 200ms",
                          }}
                          id="212121"
                        />
                      </div>
                    </Box>
                  </Box>
                )}
              </Box>
            </Box>
          ) : (
            <Box sx={{ width: "100%" }}>
              <img src={trayGuide} alt="" style={{ width: "50%" }} />
            </Box>
          )}
          {!styleValue && (
            <Box sx={{ my: 2 }}>
              <Typography
                variant="subtitle1"
                sx={{ fontWeight: "bolder", display: "inline" }}
              >
                GLASS
              </Typography>
              <Grid
                container
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  marginTop: 2,
                }}
              >
                <Grid
                  item
                  xs={12}
                  md={5.7}
                  sx={{
                    border: "2px solid #d0cece",
                    borderRadius: "10px",
                    position: "relative",
                    backgroundColor: `${
                      selectedGlass === "Art Acrylic 2mm" ? "#fafafa" : "white"
                    }`,
                    transition: "all 200ms",
                    mb: { xs: 2, md: 0 },
                  }}
                >
                  <div
                    className="glass-item"
                    onClick={glassChangeHandler}
                    id="Art Acrylic 2mm"
                  >
                    <Typography id="Art Acrylic 2mm">
                      Art Acrylic 2mm
                    </Typography>
                    <Typography sx={{ color: "#949494" }} id="Art Acrylic 2mm">
                      Optically pure & lightweight acrylic.
                    </Typography>
                  </div>

                  <CheckCircleOutlineIcon
                    sx={{
                      position: "absolute",
                      right: "-15px",
                      top: "-15px",
                      color: "#863a18",
                      backgroundColor: "white",
                      borderRadius: "100%",
                      fontSize: "35px",
                      opacity: `${
                        selectedGlass === "Art Acrylic 2mm" ? "1" : "0"
                      }`,
                      transition: "all 200ms",
                    }}
                  />
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={5.7}
                  sx={{
                    border: "2px solid #d0cece",
                    borderRadius: "10px",
                    position: "relative",
                    backgroundColor: `${
                      selectedGlass === "UV99 Art Acrylic 2mm"
                        ? "#fafafa"
                        : "white"
                    }`,
                    transition: "all 200ms",
                    mb: { xs: 2, md: 0 },
                  }}
                >
                  <div
                    className="glass-item"
                    onClick={glassChangeHandler}
                    id="UV99 Art Acrylic 2mm"
                  >
                    <Typography id="UV99 Art Acrylic 2mm">
                      UV99 Art Acrylic 2mm
                    </Typography>
                    <Typography
                      sx={{ color: "#949494" }}
                      id="UV99 Art Acrylic 2mm"
                    >
                      99% UV Filtration - protection against fading &
                      discolouration.
                    </Typography>
                  </div>

                  <CheckCircleOutlineIcon
                    sx={{
                      position: "absolute",
                      right: "-15px",
                      top: "-15px",
                      color: "#863a18",
                      backgroundColor: "white",
                      borderRadius: "100%",
                      fontSize: "35px",
                      transition: "all 200ms",
                      opacity: `${
                        selectedGlass === "UV99 Art Acrylic 2mm" ? "1" : "0"
                      }`,
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
          <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
            <button className="button" onClick={addCartHandler}>
              £
              {pricing &&
                (
                  (((Number(
                    (Number(localStorage.getItem("inputWidth")) +
                      Number(localStorage.getItem("inputHeight")) +
                      (mount && mount > 0 ? 4 * Number(mount / 2) : 0) +
                      tray * 4) *
                      2,
                  ) +
                    ((selectedFrame ? selectedFrame.width : 0) / 10) * 8) *
                    (selectedFrame ? selectedFrame.price : 0)) /
                    100 +
                    (!tray
                      ? (Number(localStorage.getItem("inputWidth")) +
                          (mount && mount > 0 ? 2 * Number(mount / 2) : 0)) *
                        (Number(localStorage.getItem("inputHeight")) +
                          (mount && mount > 0 ? 2 * Number(mount / 2) : 0)) *
                        (selectedGlass === "Art Acrylic 2mm"
                          ? pricing.get("UVAcrylic2mm_cm2") || 1
                          : pricing.get("UV99Acrylic2mm_cm2") || 1)
                      : 0) +
                    (mount && mount > 0
                      ? (Number(localStorage.getItem("inputWidth")) +
                          Number(mount)) *
                        (Number(localStorage.getItem("inputHeight")) +
                          Number(mount)) *
                        pricing.get("mount_cm2")
                      : 0) +
                    (!tray
                      ? (Number(localStorage.getItem("inputWidth")) +
                          (mount && mount > 0 ? 2 * Number(mount / 2) : 0)) *
                        (Number(localStorage.getItem("inputHeight")) +
                          (mount && mount > 0 ? 2 * Number(mount / 2) : 0)) *
                        (pricing.get("backBoard_cm2") || 0)
                      : 0) +
                    (pricing.get("hanging") || 0) +
                    (pricing.get("packing_cm2") || 0) *
                      ((Number(localStorage.getItem("inputWidth")) +
                        (mount && mount > 0 ? 2 * Number(mount / 2) : 0) +
                        tray * 2 +
                        (2 * (selectedFrame ? selectedFrame.width : 0)) / 10) *
                        (Number(localStorage.getItem("inputHeight")) +
                          (mount && mount > 0 ? 2 * Number(mount / 2) : 0) +
                          tray * 2 +
                          (2 * (selectedFrame ? selectedFrame.width : 0)) /
                            10))) *
                    (1 + (Number(pricing.get("VAT")) || 0)) *
                    (pricing.get("multiplierFactor") || 0) +
                  (localStorage.getItem("framingMode") === "artwork"
                    ? Number(artworkPrice)
                    : localStorage.getItem("framingMode") === "user"
                      ? (2e-16 *
                          Math.pow(
                            Number(
                              Number(localStorage.getItem("inputWidth")) *
                                Number(localStorage.getItem("inputHeight")) *
                                Number(pricing.get("paper_cm2")),
                            ),
                            4,
                          ) +
                          1e-11 *
                            Math.pow(
                              Number(
                                Number(localStorage.getItem("inputWidth")) *
                                  Number(localStorage.getItem("inputHeight")) *
                                  Number(pricing.get("paper_cm2")),
                              ),
                              3,
                            ) -
                          1e-7 *
                            Math.pow(
                              Number(
                                Number(localStorage.getItem("inputWidth")) *
                                  Number(localStorage.getItem("inputHeight")) *
                                  Number(pricing.get("paper_cm2")),
                              ),
                              2,
                            ) +
                          0.0117 *
                            Number(
                              Number(localStorage.getItem("inputWidth")) *
                                Number(localStorage.getItem("inputHeight")) *
                                Number(pricing.get("paper_cm2")),
                            ) +
                          3.5525) *
                        (1 + Number(pricing.get("VAT") || 0)) 
                        // *(pricing.get("multiplierFactor") || 0)
                      : 0)
                ).toFixed(2)}{" "}
              - Add to Cart
            </button>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
            <Typography>
              Artwork Size: {Number(localStorage.getItem("inputWidth"))}x
              {Number(localStorage.getItem("inputHeight"))}cm | External Frame
              Size:{" "}
              {Number(localStorage.getItem("inputWidth")) +
                (mount && mount > 0 ? 2 * Number(mount / 2) : 0) +
                tray * 2 +
                (2 * (selectedFrame ? selectedFrame.width : 0)) / 10}
              x
              {Number(localStorage.getItem("inputHeight")) +
                (mount && mount > 0 ? 2 * Number(mount / 2) : 0) +
                tray * 2 +
                (2 * (selectedFrame ? selectedFrame.width : 0)) / 10}
              cm
            </Typography>
          </Box>
        </Grid>
      </Grid>
      <Container sx={{ mb: 8 }}>
        <Grid
          container
          sx={{
            marginTop: 3,
            display: "flex",
            justifyContent: "space-between",
            mb: 20,
          }}
        >
          <Grid item xs={5.7} md={2.5}>
            <Typography
              sx={{ textAlign: "center", marginBottom: 3 }}
              variant="h6"
            >
              Frame
            </Typography>
            <Typography sx={{ color: "#949494" }}>
              100% Natural Wood
              <br /> <br />
              High Quality painted coated or stained finished UK and Italian
              woods
            </Typography>
          </Grid>
          <Grid item xs={5.7} md={2.5}>
            <Typography
              sx={{ textAlign: "center", marginBottom: 3 }}
              variant="h6"
            >
              Mount Board
            </Typography>
            <Typography sx={{ color: "#949494" }}>
              pH Neutral cardboards <br /> <br />
              Available in different colours
            </Typography>
          </Grid>
          <Grid item xs={5.7} md={2.5}>
            <Typography
              sx={{ textAlign: "center", marginBottom: 3 }}
              variant="h6"
            >
              Acrylic
            </Typography>
            <Typography sx={{ color: "#949494" }}>
              High quality optically pure, lightweight and shatterproof acrylic.
              <br /> <br />
              NOT cheap Styrene
            </Typography>
          </Grid>
          <Grid item xs={5.7} md={2.5}>
            <Typography
              sx={{ textAlign: "center", marginBottom: 3 }}
              variant="h6"
            >
              Your frame includes
            </Typography>
            <Typography sx={{ color: "#949494" }}>
              Mounting instructions
              <br /> <br />
              Handing (D-ring)
              <br /> <br />
              Backing board <br /> <br />
              Art Acrylic 2mm
            </Typography>
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <img src={guaranty} alt="Quality Guaranteed" className="guaranty" />
          <Typography variant="h6" sx={{ my: 2 }}>
            Guaranteed Quality
          </Typography>
          <Typography sx={{ color: "#949494", textAlign: "center" }}>
            All frames are custom made by our artisan team and undergoes
            <br />
            quality checks before dispatch to ensure your satisfaction.
          </Typography>
        </Box>
      </Container>
    </React.Fragment>
  );
};

export default OnlineFraming;
